var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('svg',{class:{
      svg: _vm.viewBox,
    },attrs:{"viewBox":_vm.viewBox ? _vm.viewBox : undefined}},[_c('path',{attrs:{"d":_vm.path,"fill":"none","stroke":_vm.color,"stroke-width":_vm.thickness,"stroke-linejoin":"round","stroke-linecap":"round"}})]),_c('portal',{attrs:{"to":"toolbar"}},[(_vm.selected)?_c('DrawingToolbar'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }